import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  columns,
  formFields,
  otherFields,
  initObject,
  filterFields,
  filterInitialValues,
  ObjectEditSchema,
  floorColumns,
  newprepareFilter,
  newfilterFields,
  newfilterInitialValues,
  rowFormatter,
  editRowFormatter
} from './AuditFormResultUtils';
import { AuditFormListEditPage } from './AuditFormListEditPage';


const FloorAuditFormResultPage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.floorAuditFormList }),
    shallowEqual
  );

  const { resultState } = useSelector(
    (state) => ({ resultState: state.floorAuditFormResults }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/resultForms")) {
    const temp = menuList.find(q => q.url == "/resultForms")
    isFullAccess = temp.isFullAccess;
  }


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>

          {/* {
          <Redirect
            // exact={true}
            from="/resultForms/placeFormList"
            to="/resultForms/floors"
          />
        }
        {
          <Redirect
            // exact={true}
            from="/resultForms/buildings"
            to="/resultForms/floors"
          />
        }
        {
          <Redirect
            // exact={true}
            from="/resultForms/rooms"
            to="/resultForms/floors"
          />
        } */}

          <ContentRoute
            path="/resultForms/floors/:id/edit"
            render={props =>
              <AuditFormListEditPage
                {...props}
                isFullAccess={isFullAccess}
                basePath="/resultForms/floors"
                api="api/AuditFormResult"
                methodName="GetFloorsResultByFormListId"
                updateMethodName="UpdateFloorResultStatus"
                exportfuncName="GetExportFloorsResultByFormListId"
                currentState={resultState}
                listState={currentState}
                initObject={initObject}
                columns={columns}
                formFields={formFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                prepareFilter={newprepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                // otherTabs={otherTabs}
                rowFormatter={editRowFormatter}
              />
            }
          />

          <ContentRoute
            path="/resultForms/floors"
            render={props =>
              <ObjectsPage
                getFunctionName="GetFloors"
                filterByShowButton={false}
                AuditAction={false}
                haveGeneralAction={true}
                isFullAccess={isFullAccess}
                basePath="/resultForms/floors"
                api="api/AuditFormList"
                currentState={currentState}
                columns={floorColumns}
                prepareFilter={newprepareFilter}
                filterFields={newfilterFields}
                filterInitialValues={newfilterInitialValues}
                // hideSelected={true}
                checkActive={true}
                rowFormatter={rowFormatter}
                showAuditResultForm={true}
              />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default FloorAuditFormResultPage



